/**
 * Histoire iframe setup. Runs inside the story preview frame and:
 *  - loads our base CSS (Tailwind utilities + design tokens + body defaults
 *    + prefers-reduced-motion reset)
 *  - registers a minimal Vue Router so layout components that call
 *    `useRoute()` / `<router-link>` render without errors.
 */
import { defineSetupVue3 } from '@histoire/plugin-vue'
import { createMemoryHistory, createRouter } from 'vue-router'

import '../src/styles/base.css'

const router = createRouter({
  history: createMemoryHistory(),
  routes: [
    {
      path: '/:catchAll(.*)',
      component: { template: '<div />' },
    },
  ],
})

export const setupVue3 = defineSetupVue3(({ app }) => {
  app.use(router)
})
